import http from "../http";
const EfbService = {

    Getinpectorviewlist: async () => {

        const inpectorviewlist = await http.instance.get("/EFBDevice");
        return inpectorviewlist.data
    },

    GetDevices : async (device_uuid) => {
        const devicestatistics = await http.instance.get("/EFBDevice/GetDevices/", {params: {DEVICE_UUID: device_uuid}});
        return devicestatistics.data
    },

    GetHeartBeatSignals : async (device_uuid) => {
        const hearbetsignalsstatistics = await http.instance.get("/EFBDevice/GetHeartBeatSignals/", {params: {DEVICE_UUID: device_uuid}});
        return hearbetsignalsstatistics.data
    },

    GetDeviceByUidInspectorview: async (device_uuid) =>
    {
        console.log("device uid service "+device_uuid);

        const inspectorviewDataByUid = await http.instance.get("/EFBDevice/GetInspectorViewListByUid", {params: {Device_UID: device_uuid}})
        return inspectorviewDataByUid.data;
    },

    GetDeviceSummaryList: async () =>
    {
        const inpectorviewlist = await http.instance.get("/EFBDevice/GetDeviceSummaryList");
        return inpectorviewlist.data
    },

    GetReqListOfReqTypeAndDevice: async (device_uuid,reqType,date1,date2) =>
    {
        const ReqList = await http.instance.get("/EFBDevice/RequestFile_ReqListOfReqTypeAndDevice", {
            params: {
            DEVICE_UUID: device_uuid,
            REQTYPE: reqType,
            Date1: date1,
            Date2: date2}
        });
        return ReqList.data
    },

    GetIpadRequestFile_MakeRequest: async (device_uuid,reqType,fkeyforzip,whoRequestedLast,date1,date2) =>
    {
        const ReqList = await http.instance.get("/EFBDevice/GetIpadRequestFile_MakeOneRequest", {
            params: {
                DEVICE_UUID: device_uuid,
                REQTYPE: reqType,
                FKeyForzip : fkeyforzip,
                WhoRequestedLast : whoRequestedLast,
                Date1: date1,
                Date2: date2
            }
        });

        return ReqList.data
    },

    GetZipFile :(RequestedFilePath) =>
    {
        this.http.instance.get({
            method: 'get',
            url: RequestedFilePath,
            responseType: 'arraybuffer'
        })
            .then(response => {
                //this.forceFileDownload(response)
                this.$notify({title: "Success", text: ""+response, type: "success"});
            })
            .catch((e) => this.$notify({title: "Error", text: "Error on GetZipFile function e: "+e.message, type: "error"}))
    },

    GetEFBOccSideLogs : async()=>
    {
        const OccSideLogs = await http.instance.get("/EFBDevice/GetEFBOccSideLogs/");
        return OccSideLogs.data;
    },

    GetEFBOccSideLogsWeeklyRanged : async(DayOrigin)=>
    {
        // console.log("Service MD" +MondayDate);
        // console.log("Service SD" +SundayDate);
        const OccSideLogs = await http.instance.get("/EFBDevice/GetWeeklyRangedEFBOccSideLogs/", {
            params:{
                DayOrigin:DayOrigin
            }
        });
        return OccSideLogs.data;
    },

};


export default EfbService;



